
import { LoaderFunction } from "react-router-dom";
import { apiEndpoints } from "@/services/api/api.ts";
import {
  AdminPanelPaginatedCategoryLoaderData
} from "@/routes/adminPanel/categories/main/types/adminPanelPaginatedCategoryLoaderData.ts";

export const adminPanelCategoryLoader: LoaderFunction = async ({ request }): Promise<AdminPanelPaginatedCategoryLoaderData> => {
  const url = new URL(request.url);
  const page = parseInt(url.searchParams.get("page") || "1");
  const search = url.searchParams.get("search") || "";
  const limit = 10; // Sayfa başına öğe sayısı

  try {
    // API endpoint'inizin pagination ve search parametrelerini desteklediğini varsayıyorum
    const response = await apiEndpoints.getCategories({
      pageNumber: page,
      pageSize: limit,
      search: search,
      desc: false,
      orderBy: "Title"
    });

    return {
      categories: response.data.items || response.data,
      totalPages: response.data.totalPageCount,
      currentPage: page,
      totalItems: response.data.totalItemCount
    };
  } catch (error) {
    console.error("Categories loading error:", error);
    return {
      categories: [],
      totalPages: 1,
      currentPage: 1,
      totalItems: 0
    };
  }
};